/**
 * Serviço para gerenciamento de tokens
 */
export const tokenService = {
  // Chaves do localStorage
  KEYS: {
    APP_TOKEN: 'appToken',
    USER_TOKEN: 'userToken',
    USER_DATA: 'user',
  },

  /**
   * Salva o token da aplicação
   */
  setAppToken(token) {
    localStorage.setItem(this.KEYS.APP_TOKEN, token);
  },

  /**
   * Salva o token do usuário
   */
  setUserToken(token) {
    localStorage.setItem(this.KEYS.USER_TOKEN, token);
  },

  /**
   * Retorna o token da aplicação
   */
  getAppToken() {
    const token = localStorage.getItem(this.KEYS.APP_TOKEN);
    return token && token !== 'null' && token !== 'undefined' ? token : null;
  },

  /**
   * Retorna o token do usuário
   */
  getUserToken() {
    const token = localStorage.getItem(this.KEYS.USER_TOKEN);
    return token && token !== 'null' && token !== 'undefined' ? token : null;
  },

  /**
   * Retorna o token apropriado baseado na rota
   * Rotas que começam com /users ou /entities ou /notifications ou /push usam userToken
   * Outras rotas usam appToken
   */
  getTokenForRoute(url) {
    const userRoutes = ['/users', '/entities', '/notifications', '/push', '/consultations', '/documents', '/agenda', '/medical-record', '/clinic'];
    const isUserRoute = userRoutes.some(route => url.includes(route));
    
    if (isUserRoute) {
      const userToken = this.getUserToken();
      return userToken || this.getAppToken(); // Fallback para appToken
    }
    
    return this.getAppToken();
  },

  /**
   * Salva dados do usuário
   */
  setUserData(userData) {
    localStorage.setItem(this.KEYS.USER_DATA, JSON.stringify(userData));
  },

  /**
   * Retorna dados do usuário
   */
  getUserData() {
    const userData = localStorage.getItem(this.KEYS.USER_DATA);
    if (!userData || userData === 'null' || userData === 'undefined') {
      return null;
    }
    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error('[tokenService] Error parsing user data:', error);
      return null;
    }
  },

  /**
   * Verifica se há tokens válidos
   */
  hasValidTokens() {
    return !!(this.getAppToken() && this.getUserToken());
  },

  /**
   * Verifica se o usuário está autenticado
   */
  isAuthenticated() {
    return !!(this.getUserToken() && this.getUserData());
  },

  /**
   * Limpa todos os tokens e dados
   */
  clearAll() {
    localStorage.removeItem(this.KEYS.APP_TOKEN);
    localStorage.removeItem(this.KEYS.USER_TOKEN);
    localStorage.removeItem(this.KEYS.USER_DATA);
  },
};
